"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@xstate/react");
const ApptList_utils_1 = require("./ApptList.utils");
const styles_1 = require("./styles");
const GroupedAppts_1 = __importDefault(require("./GroupedAppts"));
const moment_1 = __importDefault(require("moment"));
const Events_1 = require("../../lib/constants/Events");
const States_1 = require("../../lib/constants/States");
const LoadMoreBtn_1 = __importDefault(require("./LoadMoreBtn"));
const useManageAppointmentContext_1 = require("../../hooks/useManageAppointmentContext");
const Loading_1 = __importDefault(require("./Loading/Loading"));
const Tracking_1 = require("../../lib/constants/Tracking");
const ManageAppointmentFilterToolbar_1 = __importDefault(require("../Filters/ManageAppointmentFilterToolbar"));
const NoResults_1 = require("./NoResults");
const react_intl_1 = require("react-intl");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_2 = require("./styles");
const utils_1 = require("../../../lib/utils");
const ErrorPage_1 = __importDefault(require("../../../components/ErrorPage/ErrorPage"));
const messages_2 = __importDefault(require("../../../lib/messages"));
const PhoneNumberLink_1 = __importDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
// if we ask for 8:30 we may get a result that's
// between 8:00-8:30 and end up in an infinite loop.
// Asking for 8:31 will return 8:30-9:00
const nextPeriodStart = (availableSlots) => {
    var _a;
    return (0, moment_1.default)((_a = availableSlots[availableSlots.length - 1]) === null || _a === void 0 ? void 0 : _a.end_datetime).add(1, 'minute');
};
const ApptList = ({ service, headerHeight = 0 }) => {
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const [currentState, send] = (0, react_2.useService)(service);
    const { provider, availableSlots, jumpedToDate, filterBy } = currentState.context;
    const batchedAvailableSlots = Object.entries((0, react_1.useMemo)(() => (0, ApptList_utils_1.batchAvailableSlotsByDay)(availableSlots, filterBy), [availableSlots, filterBy]));
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const isBatchedDataEmpty = batchedAvailableSlots.length === 0;
    const isSearchResultsEmptyForDate = service.state.matches(`${States_1.newSearch}.${States_1.noResults}`);
    const isLoadMoreResultEmpty = service.state.matches(`${States_1.nextSearch}.${States_1.noResults}`);
    const isNewSearchResultsEmpty = service.state.matches(`${States_1.newSearch}.${States_1.noResults}`) && !jumpedToDate;
    const showNoResultsBanner = isBatchedDataEmpty || isSearchResultsEmptyForDate || isLoadMoreResultEmpty;
    (0, react_1.useEffect)(() => {
        if (isSearchResultsEmptyForDate) {
            track(Tracking_1.userEvents.APPT_JUMP_TO_DATE_NO_RESULTS);
        }
        if (isNewSearchResultsEmpty) {
            track(Tracking_1.userEvents.APPT_NO_RESULTS);
        }
    }, [isNewSearchResultsEmpty, isSearchResultsEmptyForDate, track]);
    if (currentState.matches(`${States_1.newSearch}.${States_1.fetchAvailableSlots}`)) {
        return react_1.default.createElement(Loading_1.default, { "data-testid": "loading-shimmer" });
    }
    const { query } = currentState.context;
    const onSelectAppt = (selectedSlot) => {
        track(Tracking_1.userEvents.APPT_SELECT_SLOT, selectedSlot);
        send({
            type: Events_1.SELECT_APPOINTMENT,
            context: { selectedSlot: selectedSlot }
        });
    };
    const onLoadMore = () => {
        track(Tracking_1.userEvents.APPT_LOAD_MORE, {
            patient_rel: query.patientRel,
            purpose: query.purpose.name,
            loaded_appointments_count: batchedAvailableSlots.length
        });
        send({
            type: Events_1.LOAD_MORE,
            data: { periodStart: nextPeriodStart(availableSlots !== null && availableSlots !== void 0 ? availableSlots : []) }
        });
    };
    if (service.state.matches(`${States_1.newSearch}.${States_1.failedFetchingslots}`)) {
        const phone = (0, utils_1.getMainContactNumber)(provider);
        return phone ? (react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_2.default.bookApptError, values: {
                phone_number_link: (react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone, onClick: () => track(Tracking_1.userEvents.APPT_TIME_ERROR_PHONE_NUMBER) }))
            } })) : (react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_2.default.bookApptErrorNoPhone }));
    }
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "ApptList", isAboveMd: aboveMd },
        react_1.default.createElement(styles_2.StyledFilterInfoContainer, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentTimeMessage))),
        react_1.default.createElement(ManageAppointmentFilterToolbar_1.default, { filterBy: filterBy, selectedDate: jumpedToDate || '', onDayChange: (dayOfWeek) => {
                track(Tracking_1.userEvents.APPT_JUMP_TO_DATE_DAY_OF_WEEK);
                send({
                    type: Events_1.SET_TOOLBAR_FILTERS,
                    data: { dayOfWeek }
                });
            }, onTimeChange: (timeOfDay) => {
                track(Tracking_1.userEvents.APPT_JUMP_TO_DATE_TIME_OF_DAY);
                send({
                    type: Events_1.SET_TOOLBAR_FILTERS,
                    data: { timeOfDay }
                });
            }, onDateChange: (date) => {
                track(Tracking_1.userEvents.APPT_JUMP_TO_DATE);
                send({
                    type: Events_1.JUMP_TO_DATE,
                    data: { periodStart: date.format('YYYY-MM-DD') }
                });
            }, onClose: () => {
                return;
            }, headerHeight: headerHeight }),
        showNoResultsBanner ? (react_1.default.createElement(NoResults_1.NoResults, { service: service, isBatchedDataEmpty: isBatchedDataEmpty, isLoadMoreResultEmpty: isLoadMoreResultEmpty, isSearchResultsEmptyForDate: isSearchResultsEmptyForDate, onLoadMore: onLoadMore })) : (react_1.default.createElement(styles_1.AppointmentSlotListContainer, null,
            batchedAvailableSlots.map(([date, slots]) => (react_1.default.createElement(GroupedAppts_1.default, { key: date, headerDate: date, availableSlotData: slots, onSelectAppt: onSelectAppt, provider: provider }))),
            react_1.default.createElement(LoadMoreBtn_1.default, { currentState: currentState, onClick: onLoadMore })))));
};
exports.default = ApptList;
//# sourceMappingURL=ApptList.js.map